<template>
  <div class="sf-el email-input">
    <div class="sf-email">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <input type="email" v-model="value" autocomplete="email" :placeholder="placeholder" />
    </div>
  </div>
</template>

<script>
  import { watch, ref } from 'vue';
  export default {
    name: 'EmailElement',
    props: {
      label: String,
      caption: String,
      placeholder: String,
      modelValue: String,
      required: Boolean,
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue);
      watch(value, (newValue) => {
        emit('update:modelValue', newValue);
      });
      return {
        value,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-email {
  }
</style>
